




























































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Area from "@/models/coding/areaModel";
import { BTableColumnType } from "@/enums/BTableColumnType";
import { PermissionValue } from '@/enums/PermissionValue';
@Component
export default class areaTableComponent extends GenericBTable<Area> {

  created() {
    this.permissionValue = PermissionValue.CODIFICACIONES;

    this.tableConfig.controller = "Areas";
    this.formatColumns();
  }

  formatColumns() {
    let name = new BTableColumn("name", "table.name", false);
    let code = new BTableColumn("code", "table.code", true);
    this.tableConfig.insertColumns(name, code);
    this.tableConfig.actions.customTemplate = true;
  }
  verOpciones(row: Area) {
    this.$router.push(`/Area/${row.id}/FieldArea`);
  }
}
